import { List } from 'immutable';
export default function makeSelectTableCell(store) {
  return {
    selectTableCell: function selectTableCell(editor, cell) {
      var tableId = cell.getIn(['data', 'tableId']);
      var previous = store.getItem(tableId) || {};
      var selectedCellKeys = previous.selectedCellKeys || new List();
      var selectedCellsCoords = previous.selectedCellsCoords || new List();
      var cellCoords = editor.getCellCoords(cell);
      store.updateItem(store.getItem('lastFocusedTableId'), {});
      store.updateItem('lastFocusedTableId', tableId);
      store.updateItem(tableId, {
        selectedCellKeys: selectedCellKeys.push(cell.key),
        selectedCellsCoords: selectedCellsCoords.push(cellCoords)
      });
      return editor.snapshotSelection().withoutSaving(function () {
        return editor.deselect();
      });
    }
  };
}